export function getStoredListPage(storageKey: string) {
  if (globalThis.sessionStorage === undefined) return 0;

  const storedPage = globalThis.sessionStorage.getItem(storageKey);

  if (storedPage === null) return 0;

  const parsedPage = Number.parseInt(storedPage, 10);

  if (Number.isNaN(parsedPage) || parsedPage < 0) return 0;

  return parsedPage;
}

export function setStoredListPage(storageKey: string, page: number) {
  if (globalThis.sessionStorage === undefined) return;

  globalThis.sessionStorage.setItem(storageKey, String(page));
}
